import {
  FORTRESS_ACTIVITY_DASHBOARD,
  FORTRESS_CREATE_REPORTS,
} from 'src/app/reporting/services/ReportingServiceConstants';
import { Policy } from './Policy';
import { PolicyElement } from './PolicyElement';

export class ActivityPolicy extends Policy {
  override readonly keyStart = new RegExp(
    `^${FORTRESS_CREATE_REPORTS}\\.${FORTRESS_ACTIVITY_DASHBOARD}\\.`,
  );

  etf = new PolicyElement('ETF');
  platform = new PolicyElement('PLATFORM');
  tables = new PolicyElement('TABLES');

  constructor() {
    super();
    this.policyElements.push(this.etf, this.platform, this.tables);
  }
}
